import React, {useRef} from 'react';
import Modal from '@material-ui/core/Modal';
import Typography from "@material-ui/core/Typography";
import {Card,CardContent} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import GenericModal from '../GenericModal'
import {Formik,Field} from "formik";
import TextField from '@material-ui/core/TextField';
import clsx from "clsx";
import MenuItem from "@material-ui/core/MenuItem";
import * as Yup from 'yup'
import CreateEditUserForm from "../../Forms/Users/CreateEditUserForm";
import axios from 'axios'
import {STORE_USER} from '../../../api/Api'


function rand() {
    return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}


const useStyles = makeStyles(theme => ({
    modalContainer: {
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        outline: 'none',
    },
    textFieldContainer: {
        display: 'block',
        width: '100%'
    }
}));

const ValidationSchema = Yup.object().shape(
    {
        nom: Yup.string().required('Vous devez saisir le nom de l\'utilisateur'),
        prenoms: Yup.string().required('Vous devez saisir le prénoms de l\'utilisateur'),
        matricule: Yup.string().required('Vous devez saisir le matricule de l\'utilisateur'),
        societe: Yup.string().required('Vous devez sélectionner la societé'),
        phone: Yup.string().matches(
            /^[0-9]{10}$/, 'Vous devez saisir un numéro de téléphone valide'
        ).required('Champ obligatoire'),
        email: Yup.string().email('Vous devez saisir une adresse email valide').required('Vous devez saisir l\'adresse email de l\'utilisateur')
            .matches(
                /^([-A-Za-z0-9]+)@(gs2e|cie|sodeci)\.(ci)$/,
                "Vous devez utilisé une adresse email 'gs2e' ou 'cie'"
            ),
        password: Yup.string()
            .required('Vous devez saisir le mot de passe')
            .min(8,'Votre mot de passe doit contenir au moins 8 caractères')
            .matches(
                /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&"'()§^:;,])[A-Za-z\d@$!%*#?&"'()§^:;,]{8,}$/,
                "Le mot de passe doit contenir 8 caractères, et au moins une majuscule, une minuscule , un chiffre et un symbole"
            ),
        role: Yup.number().required('Vous devez selectionner le role'),

    }
);

export default function CreateUserModal (props){

        const {onUserCreated,onCancel,...otherProps} = props;

        const formRef = useRef(null);

        const [isCreatingUser,setIsCreatingUser] = React.useState(false);

        function submitForm(){

            if(formRef.current)
                formRef.current.submitForm();

        }

        function hydrateFormWithError(errors){

            console.log(formRef)
            console.log(errors)

            if(errors.data.violations)
                errors.data.violations.forEach(
                        item => {
                            formRef.current.setFieldError(item.propertyPath,item.message)
                        }
                    )

            else{
                //TODO: display some error alert
                console.log('Une erreur est survenue')
            }

        }

        async function onFormSubmitted(value){

            setIsCreatingUser(true)

            try {

                const computedLocations = value.locations.map(
                    item => {

                        if(item.rue)
                            return {location_type: 'rue',location_id: item.rue}

                        if(item.quartier)
                            return {location_type: 'quartier',location_id: item.quartier}

                        if(item.commune)
                            return {location_type: 'commune',location_id: item.commune}

                        if(item.ville)
                            return {location_type: 'ville',location_id: item.ville}

                    }
                );

                const response = await axios.post(STORE_USER,{
                    email: value.email,
                    nom: value.nom,
                    role: value.role,
                    societe: value.societe,
                    matricule: value.matricule,
                    locations: computedLocations,
                    prenoms: value.prenoms,
                    phone: value.phone,
                    password: value.password,
                    hasUpdatePassword: false
                });

                onUserCreated(response.data);

            } catch (e) {

                if(e.response){

                    switch (e.response.status) {
                        case 400:
                                hydrateFormWithError(e.response)
                            break;
                    }

                }

            } finally {
                setIsCreatingUser(false);
            }

        }

        return (
            <GenericModal
                {...otherProps}
                title={'Ajoutez un utilisateur'}
                negativeText={'Annnuler'}
                positiveText={'Ajouter l\'utilisateur'}
                onPositive={submitForm}
                onNegative={onCancel}
                isSubmittingData={isCreatingUser}
            >

                <CreateEditUserForm initialValues={
                    {
                        nom: '',
                        prenoms: '',
                        role: '',
                        email: '',
                        matricule: '',
                        societe: '',
                        phone: '',
                        password: '',
                        ville_id: '',
                        commune_id: '',
                        quartier_id: '',
                        locations: []
                    }
                }

                                    ValidationSchema={ValidationSchema}
                                    onSubmitForm={onFormSubmitted} ref={formRef} />

            </GenericModal>
        );

}